import edliban6101 from '../assets/certificates/EDLiban6101.png';
import edliban6102 from '../assets/certificates/EDLiban6102.png';
import edliban4092 from '../assets/certificates/EDLiban4092.png';
import edliban4090 from '../assets/certificates/EDLiban4090.png';
import iso14001 from '../assets/certificates/medcables_14001-2015.png';
import iso45001 from '../assets/certificates/medcables_45001-2018.png';
import iso9001 from '../assets/certificates/ISO9001.png';
import EDLiban5117 from '../assets/certificates/EDLiban5117.png';
import MOE52360 from '../assets/certificates/MOE52360.png';
import CertofConformity from '../assets/certificates/CertofConformity.png';
import typetest from '../assets/certificates/typetest.png';
import iri from '../assets/certificates/iri.png';
import iri2 from '../assets/certificates/iri2.png';
import testTUV from '../assets/certificates/testTUV.png';
import qualiconsult from '../assets/certificates/qualiconsult.png';

import edliban6101pdf from '../assets/certificates/EDLiban6101.pdf';
import edliban6102pdf from '../assets/certificates/EDLiban6102.pdf';
import edliban4092pdf from '../assets/certificates/EDLiban4092.pdf';
import edliban4090pdf from '../assets/certificates/EDLiban4090.pdf';
import iso14001pdf from '../assets/certificates/medcables_14001-2015.pdf';
import iso45001pdf from '../assets/certificates/medcables_45001-2018.pdf';
import iso9001pdf from '../assets/certificates/ISO9001.pdf';
import EDLiban5117pdf from '../assets/certificates/EDLiban5117.pdf';
import MOE52360pdf from '../assets/certificates/MOE52360.pdf';
import CertofConformitypdf from '../assets/certificates/CertofConformity.pdf';
import typetestpdf from '../assets/certificates/typetest.pdf';
import iripdf from '../assets/certificates/iri.pdf';
import iri2pdf from '../assets/certificates/iri2.pdf';
import testTUVpdf from '../assets/certificates/testTUV.pdf';
import qualiconsultpdf from '../assets/certificates/qualiconsult.pdf';

export const certificates = [
    {
      id: 1,
      title: 'ED Liban 6101',
      issuer: 'ELECTRICITE DU LIBAN',
      preview: edliban6101,
      file: edliban6101pdf,
      color: '#3498db'
    },
    {
      id: 2,
      title: 'ED Liban 6102',
      issuer: 'ELECTRICITE DU LIBAN',
      preview: edliban6102,
        file: edliban6102pdf,
      color: '#2ecc71'
    },
    {
      id: 3,
      title: 'ED Liban 4092',
      issuer: 'ELECTRICITE DU LIBAN',
      preview: edliban4092,
      file: edliban4092pdf,
      color: '#2ecc71'
    },
    {
      id: 4,
      title: 'ED Liban 4090',
      issuer: 'ELECTRICITE DU LIBAN',
      preview: edliban4090,
      file: edliban4090pdf,
      color: '#2ecc71'
    },
    {
      id: 5,
      title: 'ISO 14001:2015',
      issuer: 'MQA',
      preview: iso14001,
      file: iso14001pdf,
      color: '#2ecc71'
    },
    {
      id: 6,
      title: 'ISO 45001:2018',
      issuer: 'MQA',
      preview: iso45001,
      file: iso45001pdf,
      color: '#2ecc71'
    },
    {
      id: 7,
      title: 'ISO 9001:2015',
      issuer: 'MQA',
      preview: iso9001,
      file: iso9001pdf,
      color: '#2ecc71'
    },
    {
      id: 8,
      title: 'ED Liban 5117',
      issuer: 'ELECTRICITE DU LIBAN',
      preview: EDLiban5117,
      file: EDLiban5117pdf,
      color: '#2ecc71'
    },
    {
      id: 9,
      title: 'Classifications in Iraq',
      issuer: 'Ministry of Electricity',
      preview: MOE52360,
      file: MOE52360pdf,
      color: '#2ecc71'
    },
    {
      id: 10,
      title: 'Exported Goods to Kurdistan',
      issuer: 'intertek',
      preview: CertofConformity,
      file: CertofConformitypdf,
      color: '#2ecc71'
    },
    {
      id: 11,
      title: 'Type Test IEC',
      issuer: 'IEC',
      preview: typetest,
      file: typetestpdf,
      color: '#2ecc71'
    },
    {
      id: 12,
      title: 'IRI Test for Cables',
      issuer: 'IRI',
      preview: iri,
      file: iripdf,
      color: '#2ecc71'
    },
    {
      id: 13,
      title: 'IRI Test Report Iraq',
      issuer: 'IRI',
      preview: iri2,
      file: iri2pdf,
      color: '#2ecc71'
    },
    {
      id: 14,
      title: 'Test by TUV',
      issuer: 'TUV',
      preview: testTUV,
      file: testTUVpdf,
      color: '#2ecc71'
    },
    {
      id: 15,
      title: 'Cables Tests Witnessing Report',
      issuer: 'Qualiconsult',
      preview: qualiconsult,
      file: qualiconsultpdf,
      color: '#2ecc71'
    }

  ];